module.exports = {
      id: "ic-measure-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-measure-usage",
      toString: function () {
        return this.url;
      }
    }